export default {
  data() {
    return {
      activeIndex: -1,
      activeCheckbox: null,
      activedescendant: '' // Using aria-activedescendant to Manage Focus
    };
  },

  computed: {
    checkboxList() {
      // force dep collection
      this.options;
      const list = this.$el.querySelectorAll('input[type=checkbox]');
      return list;
    }
  },

  watch: {
    activeIndex(val) {
      if (typeof val === 'number' && val > -1) {
        const activeCheckbox = this.checkboxList[val];
        if (activeCheckbox) {
          this.activedescendant = activeCheckbox.id;
          activeCheckbox.focus();
        }
      }
    }
  },

  methods: {
    navigateCheckbox(direction) {
      if (this.options.length === 0) {
        return;
      }
      if (direction === 'next') {
        this.activeIndex++;
        if (this.activeIndex >= this.options.length + 1) {
          this.activeIndex = 0;
        }
      } else if (direction === 'prev') {
        this.activeIndex--;
        if (this.activeIndex < 0) {
          this.activeIndex = this.options.length;
        }
      } else if (direction === 'home') {
        this.activeIndex = 0;
      } else if (direction === 'end') {
        this.activeIndex = this.options.length;
      }
    }
  }
};
